// import JSEncrypt from 'jsencrypt'

import JSEncrypt from 'jsencrypt/bin/jsencrypt.js';

// 加密
export function encrypt(publicKey,txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(txt); // 对数据进行加密
}


// WEBPACK FOOTER //
// ./src/utils/jsencrypt.js